import React from "react";
import { useNavigate } from "react-router-dom";
import "./css/dilemmaInstructions.css";
import useTranslation from "../hooks/useTranslation";

function DilemmaInstructions({ gameData, updateProgress }) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleStart = () => {
    updateProgress('dilema-instructions');
    console.log('Botón START presionado - Dilema con datos:', gameData);
    navigate('/dilema-risk-selection');
  };

  return (
    <div className="dilema-container">
      {/* Contenido central */}
      <div className="dilema-content">
        <div className="dilema-header">
          <h1 className="game-titleD">{t('dilemmaInstructions.gameTitle')}</h1>
          <h2 className="game-subtitleD">{t('dilemmaInstructions.gameSubtitle')}</h2>
        </div>

        <div className="instructions-box">
          <h2 className="instructions-title">{t('dilemmaInstructions.subtitle')} {t('dilemmaInstructions.title')}</h2>
          
          <div className="instructions-text">
            <p>
              {t('dilemmaInstructions.paragraph1')}
            </p>
            
            <p>
              {t('dilemmaInstructions.paragraph2')}
            </p>
          </div>

          <button className="start-button" onClick={handleStart}>
            {t('dilemmaInstructions.startButton')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default DilemmaInstructions;

